import { useQuery, QueryResult } from '@eika-infrastruktur/react-query';

import type { Country, CountryCode, CountryDetails } from '../generated-types';
import { getCountryDetails, getBankCountries, getReceiverResidenceCountries } from '../services/countriesService';

export const useBankCountries = (): QueryResult<Country[]> =>
    useQuery<Country[]>({
        queryKey: ['countries'],
        queryFn: getBankCountries,
    });

export const useReceiverResidenceCountries = (): QueryResult<Country[]> =>
    useQuery({
        queryKey: ['receiver-countries'],
        queryFn: getReceiverResidenceCountries,
    });

export const useCountryDetails = (
    countryCode?: CountryCode,
    successCallback?: (data: CountryDetails) => void,
): QueryResult<CountryDetails> =>
    useQuery({
        queryKey: ['country', countryCode?.value],
        queryFn: () => getCountryDetails(countryCode!),
        enabled: !!countryCode,
        staleTime: Infinity,
        onSuccess: successCallback,
    });
